"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _globalComponentsLibrary = require("global-components-library");
var _reactI18next = require("react-i18next");
var _slate = require("slate");
var _slateReact = require("slate-react");
var _ToggleChip = _interopRequireDefault(require("../common/ToggleChip/ToggleChip"));
var _AddressInput = _interopRequireDefault(require("../common/AddressInput/AddressInput"));
var _IconButton = _interopRequireDefault(require("../common/IconButton/IconButton"));
var _types = require("../../utils/types");
var _helpers = require("../../utils/helpers");
var _LinksModal = _interopRequireDefault(require("../LinksModal/LinksModal"));
var _TextEditor = _interopRequireDefault(require("./TextEditor"));
var _SlateUtils = require("./SlateUtils");
require("./MailEditor.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var MailEditor = function MailEditor(_ref) {
  var id = _ref.id,
    to = _ref.to,
    from = _ref.from,
    originalMail = _ref.originalMail,
    addressList = _ref.addressList,
    loading = _ref.loading,
    onSend = _ref.onSend,
    onDiscard = _ref.onDiscard,
    onUploadAttachments = _ref.onUploadAttachments,
    onDeleteAttachment = _ref.onDeleteAttachment,
    IsAzure = _ref.IsAzure,
    draft = _ref.draft,
    onUpdateDraftMessage = _ref.onUpdateDraftMessage,
    onUpdateDraftAttachments = _ref.onUpdateDraftAttachments,
    onDeleteDraftMessage = _ref.onDeleteDraftMessage;
  var _useTranslation = (0, _reactI18next.useTranslation)('mail-editor'),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    ccOpen = _useState2[0],
    setCCOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    bccOpen = _useState4[0],
    setBCCOpen = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    cc = _useState6[0],
    setCC = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    bcc = _useState8[0],
    setBCC = _useState8[1];
  var _useState9 = (0, _react.useState)(true),
    _useState10 = _slicedToArray(_useState9, 2),
    formatOpen = _useState10[0],
    setFormatOpen = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    linksModalOpen = _useState12[0],
    setLinksModalOpen = _useState12[1];
  var _useState13 = (0, _react.useState)(null),
    _useState14 = _slicedToArray(_useState13, 2),
    url = _useState14[0],
    setUrl = _useState14[1];
  var _useState15 = (0, _react.useState)(null),
    _useState16 = _slicedToArray(_useState15, 2),
    text = _useState16[0],
    setText = _useState16[1];
  var handleInsertLink = function handleInsertLink(link) {
    if (text && url) {
      _SlateUtils.UINEditor.wrapLinkUpdate(editor, link.url, link.text, url, text);
    } else {
      _SlateUtils.UINEditor.wrapLink(editor, link.url, link.text);
    }
  };
  var handleDeleteLink = function handleDeleteLink(url, text) {
    _SlateUtils.UINEditor.changTypeLinkNode(editor, url, text);
  };
  var fileInputRef = (0, _react.useRef)();
  var _useState17 = (0, _react.useState)(draft.attachments),
    _useState18 = _slicedToArray(_useState17, 2),
    attachments = _useState18[0],
    setAttachments = _useState18[1];
  var handleAttachments = function handleAttachments(files) {
    //upload files to server first
    if (files.length === 1 && (0, _helpers.isImageType)(files[0])) {
      var reader = new FileReader();
      reader.addEventListener('load', function () {
        var url = reader.result;
        if (IsAzure) {
          _SlateUtils.UINEditor.insertImage(editor, url, files[0].name, IsAzure);
        } else {
          _SlateUtils.UINEditor.insertImage(editor, url);
        }
      });
      reader.readAsDataURL(files[0]);
      if (IsAzure) {
        var fileArr = _toConsumableArray(files);
        setAttachments(function (atts) {
          return [].concat(_toConsumableArray(atts), _toConsumableArray(fileArr.map(function (f) {
            return {
              name: f.name,
              invalidSize: f.size > 10000000,
              unsafeType: (0, _helpers.isUnsafeFile)(f),
              IsInline: true
            };
          })));
        });
        fileArr.map(function (f) {
          if (!(0, _helpers.isUnsafeFile)(f) && !(f.size > 10000000)) {
            var temp = (0, _helpers.mimeTypeLeft)(f.type);
            var type = temp !== 'image' && temp !== 'video' && temp !== 'audio' ? 'file' : temp;
            var _url = window.URL.createObjectURL(f);
            f.preview = {
              type: type,
              url: _url
            };
            f.urllocal = _url;
            onUploadAttachments([f]);
          }
          return f;
        });
      }
    } else {
      var _fileArr = _toConsumableArray(files);
      setAttachments(function (atts) {
        return [].concat(_toConsumableArray(atts), _toConsumableArray(_fileArr.map(function (f) {
          return {
            name: f.name,
            invalidSize: f.size > 10000000,
            unsafeType: (0, _helpers.isUnsafeFile)(f),
            IsInline: false
          };
        })));
      });
      _fileArr.map(function (f) {
        if (!(0, _helpers.isUnsafeFile)(f) && !(f.size > 10000000)) {
          var temp = (0, _helpers.mimeTypeLeft)(f.type);
          var type = temp !== 'image' && temp !== 'video' && temp !== 'audio' ? 'file' : temp;
          var _url2 = window.URL.createObjectURL(f);
          f.preview = {
            type: type,
            url: _url2
          };
          f.urllocal = _url2;
          onUploadAttachments([f]);
        }
      });
    }
  };
  var onChangeHandler = function onChangeHandler(url, text) {
    setUrl(url);
    setText(text);
    setLinksModalOpen(!linksModalOpen);
  };
  (0, _react.useEffect)(function () {
    if (!linksModalOpen) {
      setUrl(null);
      setText(null);
    }
  }, [linksModalOpen]);
  (0, _globalComponentsLibrary.useUpdateEffect)(function () {
    onUpdateDraftAttachments(id, attachments);
  }, [id, attachments]);
  var _useState19 = (0, _react.useState)(false),
    _useState20 = _slicedToArray(_useState19, 2),
    quotedOpen = _useState20[0],
    setQuotedOpen = _useState20[1];
  var editor = (0, _react.useMemo)(function () {
    return (0, _SlateUtils.withImages)((0, _SlateUtils.withLinks)((0, _slateReact.withReact)((0, _slate.createEditor)())));
  }, []);
  var _useState21 = (0, _react.useState)(draft.data),
    _useState22 = _slicedToArray(_useState21, 2),
    value = _useState22[0],
    setValue = _useState22[1];
  var handleSend = function handleSend() {
    var htmlMessage = _SlateUtils.UINEditor.serialize(editor);
    var dataAttachments = attachments.map(function (a) {
      return [{
        ContentId: a.name,
        IsInline: a.IsInline
      }];
    });
    dataAttachments = [].concat.apply([], dataAttachments);
    onSend(id, 'Re: ' + originalMail.subject, htmlMessage, dataAttachments, cc.map(function (c) {
      return c.account;
    }), bcc.map(function (c) {
      return c.account;
    }), IsAzure);
    setValue([{
      type: 'paragraph',
      children: [{
        text: '',
        font: 'Arial',
        size: '14px'
      }]
    }]);
    _SlateUtils.UINEditor.deleteMark(editor);
  };
  (0, _react.useEffect)(function () {
    if (draft) {
      setValue(draft.data);
      setAttachments(draft.attachments);
    } else {
      handleDiscard();
    }
  }, [id]);
  var onChangeEditor = function onChangeEditor(value) {
    setValue(value);
    onUpdateDraftMessage(id, value);
  };
  var handleDiscard = function handleDiscard() {
    onDiscard();
    setQuotedOpen(false);
    setCCOpen(false);
    setCC([]);
    setBCCOpen(false);
    setBCC([]);
    setFormatOpen(true);
    attachments.forEach(function (f) {
      if (!f.unsafeType && !f.invalidSize) {
        onDeleteAttachment(f.name);
      }
    });
    setAttachments([]);
    _SlateUtils.UINEditor.resetSelection(editor);
    editor.selection = {
      anchor: {
        path: [0, 0],
        offset: 0
      },
      focus: {
        path: [0, 0],
        offset: 0
      }
    };
    setValue([{
      type: 'paragraph',
      children: [{
        text: '',
        font: 'Arial',
        size: '14px'
      }]
    }]);
    onDeleteDraftMessage(id);
  };
  var onDeleteAttachmentHandle = function onDeleteAttachmentHandle(a, i) {
    if (!a.unsafeType && !a.invalidSize) {
      onDeleteAttachment(a.name);
    }
    setAttachments(function (atts) {
      return atts.filter(function (_, index) {
        return index !== i;
      });
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-mail-editor"
  }, /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.DragNDrop, {
    placeholder: t('drop-files'),
    onFileDrop: handleAttachments
  }), /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-med-to"
  }, to.name, " (", to.account, ")"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-med-chips"
  }, /*#__PURE__*/_react["default"].createElement(_ToggleChip["default"], {
    id: 'uin-med-cc-chip-' + id,
    label: t('cc'),
    tabIndex: 1,
    active: ccOpen,
    toggle: function toggle() {
      return setCCOpen(!ccOpen);
    }
  }), /*#__PURE__*/_react["default"].createElement(_ToggleChip["default"], {
    id: 'uin-med-bcc-chip-' + id,
    label: t('bcc'),
    tabIndex: 2,
    active: bccOpen,
    toggle: function toggle() {
      return setBCCOpen(!bccOpen);
    }
  }))), /*#__PURE__*/_react["default"].createElement(_reactstrap.Collapse, {
    isOpen: ccOpen,
    className: "uin-med-addr"
  }, /*#__PURE__*/_react["default"].createElement(_AddressInput["default"], {
    label: t('cc'),
    list: addressList,
    selected: cc,
    onSelect: function onSelect(c) {
      return setCC(function (l) {
        return [].concat(_toConsumableArray(l), [c]);
      });
    },
    onEdit: function onEdit(index, contact) {
      return setCC(function (l) {
        return (0, _helpers.updateArrayImmutably)(l, index, contact);
      });
    },
    onDelete: function onDelete(index) {
      return setCC(function (l) {
        return l.filter(function (_, i) {
          return i !== index;
        });
      });
    }
  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.Collapse, {
    isOpen: bccOpen,
    className: "uin-med-addr"
  }, /*#__PURE__*/_react["default"].createElement(_AddressInput["default"], {
    label: t('bcc'),
    list: addressList,
    selected: bcc,
    onSelect: function onSelect(c) {
      return setBCC(function (l) {
        return [].concat(_toConsumableArray(l), [c]);
      });
    },
    onEdit: function onEdit(index, contact) {
      return setBCC(function (l) {
        return (0, _helpers.updateArrayImmutably)(l, index, contact);
      });
    },
    onDelete: function onDelete(index) {
      return setBCC(function (l) {
        return l.filter(function (_, i) {
          return i !== index;
        });
      });
    }
  })), /*#__PURE__*/_react["default"].createElement(_slateReact.Slate, {
    editor: editor,
    value: value,
    onChange: function onChange(value) {
      return onChangeEditor(value);
    }
  }, /*#__PURE__*/_react["default"].createElement(_TextEditor["default"], {
    id: id,
    to: to,
    from: from,
    originalMail: originalMail,
    formatOpen: formatOpen,
    attachments: attachments,
    quotedOpen: quotedOpen,
    setQuotedOpen: setQuotedOpen,
    disabled: loading,
    onDeleteAttachment: onDeleteAttachmentHandle,
    setLinksModalOpen: onChangeHandler,
    handleDeleteLink: handleDeleteLink
  })), /*#__PURE__*/_react["default"].createElement("footer", null, /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
    color: "primary",
    onClick: handleSend,
    disabled: loading || attachments && attachments.some(function (i) {
      return i.unsafeType === true || i.invalidSize;
    })
  }, t('send')), loading ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
    color: "primary"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-med-loading-label"
  }, t('sending'))) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    id: 'uin-med-format-icon-' + id,
    icon: "text-edit",
    secondary: true,
    active: formatOpen,
    onClick: function onClick() {
      return setFormatOpen(!formatOpen);
    }
  }), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    id: 'uin-med-attach-icon-' + id,
    icon: "clip-right",
    secondary: true,
    onClick: function onClick() {
      return fileInputRef.current.click();
    }
  }), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    id: 'uin-med-link-icon-' + id,
    icon: "link",
    secondary: true,
    onClick: function onClick() {
      return setLinksModalOpen(!linksModalOpen);
    }
  })), /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    id: 'uin-med-discard-icon-' + id,
    icon: "trash",
    secondary: true,
    disabled: loading,
    onClick: handleDiscard
  })), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: 'uin-med-cc-chip-' + id,
    offset: "0,4"
  }, t('add-cc')), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: 'uin-med-bcc-chip-' + id,
    offset: "0,4"
  }, t('add-bcc')), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: 'uin-med-toggle-quote-' + id,
    offset: "0,8"
  }, t('show-quoted')), !loading && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: 'uin-med-format-icon-' + id,
    offset: "0,4"
  }, t('format')), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: 'uin-med-attach-icon-' + id,
    offset: "0,4"
  }, t('attach')), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: 'uin-med-link-icon-' + id,
    offset: "0,4"
  }, t('link'))), /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: 'uin-med-discard-icon-' + id,
    offset: "0,4"
  }, t('discard')), /*#__PURE__*/_react["default"].createElement(_LinksModal["default"], {
    isOpen: linksModalOpen,
    setOpen: setLinksModalOpen,
    onInsert: handleInsertLink,
    inittext: text,
    initurl: url
  }), /*#__PURE__*/_react["default"].createElement("input", {
    type: "file",
    hidden: true,
    multiple: true,
    ref: fileInputRef,
    onChange: function onChange(e) {
      return handleAttachments(e.currentTarget.files);
    }
  }));
};
MailEditor.propTypes = {
  id: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,
  to: _types.contactType.isRequired,
  from: _types.contactType.isRequired,
  originalMail: _types.messageType,
  addressList: _propTypes["default"].arrayOf(_types.contactType),
  onDiscard: _propTypes["default"].func.isRequired
};
MailEditor.defaultProps = {
  draft: {
    data: [{
      type: 'paragraph',
      children: [{
        text: '',
        font: 'Arial',
        size: '14px'
      }]
    }],
    attachments: []
  }
};
var _default = exports["default"] = MailEditor;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/MailEditor/MailEditor.js
// module id = 1413
// module chunks = 0